import { useOnMount } from '@ardoq/hooks';
import { useState } from 'react';
import { subscribe, unsubscribe } from './stateManager';
import { StackPageItem } from './types';
import * as stackPageFunctions from './stackPageFunctions';

export const useStackPageManager = () => {
  const [stack, setStack] = useState<StackPageItem[]>([]);
  useOnMount(() => {
    const subscriptionId = subscribe(({ stack }) => setStack(stack));
    return () => unsubscribe(subscriptionId);
  });
  return { stack, ...stackPageFunctions };
};
